import { inject, Injectable } from '@angular/core';
import { TranscribeErrorHandler } from '@xmedical/transcribe';
import { RollbarService } from './rollbar.service';
import Rollbar from 'rollbar';

/**
 * Rollbar implementation of TranscribeErrorHandler
 * Adapts the Rollbar service to the TranscribeErrorHandler interface
 * for use with the xmedical-transcribe library
 */
@Injectable({ providedIn: 'root' })
export class RollbarTranscribeErrorHandler implements TranscribeErrorHandler {
  private rollbar: Rollbar = inject(RollbarService);

  error(message: string, error?: unknown): void {
    console.error(`[Transcribe] ${message}`, error);
    this.rollbar.error(`[Transcribe] ${message}`, error as Error);
  }

  warn(message: string): void {
    console.warn(`[Transcribe] ${message}`);
    this.rollbar.warning(`[Transcribe] ${message}`);
  }

  info(message: string): void {
    console.log(`[Transcribe] ${message}`);
    this.rollbar.info(`[Transcribe] ${message}`);
  }
}
